import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import { CheckInputBaseProps } from "./CheckInputBase.types";
import { StyledCheckInputBase } from "./styling/CheckInputBase.styles";

const CheckInputBase: FC<CheckInputBaseProps> = ({
	children,
	className,
	...props
}) => {
	const block = new BemIt("CheckInputBase");

	return (
		<StyledCheckInputBase
			className={addClass(className).after(block)}
			{...props}
		>
			{children}
		</StyledCheckInputBase>
	);
};

export default CheckInputBase;
